import { render, staticRenderFns } from "./gameAuditList.vue?vue&type=template&id=57ca92cc&scoped=true"
import script from "./gameAuditList.vue?vue&type=script&lang=js"
export * from "./gameAuditList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ca92cc",
  null
  
)

export default component.exports